import { IAPIResponse } from "../interfaces/api";
import { IGameCheckerApprovalResponse, IGameCheckerRejectionResponse, IGameSendForApprovalResponse } from "../interfaces/game-info";
import { config } from "../utils/config";
import { log } from "../utils/logger";
import { formatURL } from "../utils/utils";


export const getSentForApprovalList = async <Type>(userName: string): Promise<IAPIResponse<Array<Type>>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/approval/list?userName=${userName}`;
    const headers = new Headers();

    log.debug(`getMakerCheckerList HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'GET', headers });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}

export const sendGameForApproval = async (lanid: string, gameName: string, operation: string, reason: string): Promise<IAPIResponse<IGameSendForApprovalResponse>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/submit/${gameName}/${operation}?userName=${lanid}`;
    const headers = new Headers();
    headers.append("Content-Type", "application/json");

    log.debug(`sendGameForApproval HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'POST', headers, body: JSON.stringify({ "reason": reason }) });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}

export const approveGame = async (lanid: string, gameName: string, reason: string): Promise<IAPIResponse<IGameCheckerApprovalResponse>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/approval/accept/${gameName}?userName=${lanid}`;
    const headers = new Headers();
    headers.append("Content-Type", "application/json");

    log.debug(`approveGame HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'POST', headers, body: JSON.stringify({ "reason": reason }) });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}

export const rejectGame = async (lanid: string, gameName: string, reason: string): Promise<IAPIResponse<IGameCheckerRejectionResponse>> => {
    const selectedURL = `${formatURL(config.GamificationEngineBaseURL)}api/v1/game/approval/reject/${gameName}?userName=${lanid}`;
    const headers = new Headers();
    headers.append("Content-Type", "application/json");

    log.debug(`rejectGame HTTP request URL: ${selectedURL}`);

    try {
        const apiResponse: Response = await fetch(selectedURL, { method: 'POST', headers, body: JSON.stringify({ "reason": reason }) });

        return {
            status: apiResponse.ok,
            response: await apiResponse.json(),
            error: null,
        }
    } catch (error: any) {
        return {
            status: false,
            response: null,
            error,
        }
    }
}